
import React, { useState } from "react";
import axios from "axios";
import Content from "../../../Components/Dashboard/Content/Content";


const styles = {
  container: {
    maxWidth: "600px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  chatBox: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    padding: "15px",
    height: "500px",
    overflowY: "auto",
    marginBottom: "10px",
  },
  message: {
    margin: "10px 0",
    display: "flex",
  },
  userMessage: {
    marginLeft: "auto",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "15px",
    padding: "10px 15px",
    maxWidth: "70%",
  },
  botMessage: {
    marginRight: "auto",
    backgroundColor: "#f1f1f1",
    color: "#000",
    borderRadius: "15px",
    padding: "10px 15px",
    maxWidth: "70%",
  },
  quickReplies: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
    marginBottom: "10px",
  },
  quickButton: {
    padding: "10px",
    backgroundColor: "#e6f0ff",
    border: "1px solid #ccc",
    borderRadius: "10px",
    cursor: "pointer",
    textAlign: "center",
  },
  form: {
    display: "flex",
    gap: "10px",
  },
  input: {
    flex: 1,
    padding: "10px",
    borderRadius: "10px",
    border: "1px solid #ccc",
  },
  sendButton: {
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
  },
  image: {
    maxWidth: "200px",
    borderRadius: "10px",
  },
};

const ChatBotPage = () => {
  let UserName =
    JSON.parse(localStorage.getItem("user_details"))?.UserName || "User";

  const [messages, setMessages] = useState([
    {
      type: "bot",
      text:
        "👋 Welcome to " + UserName + " Assistant! How can I help you today?",
    },
  ]);
  const [input, setInput] = useState("");
  const [showQuickReplies, setShowQuickReplies] = useState(true);
  const [uploadingImage, setUploadingImage] = useState(null);

  const sendMessage = async (text, isFile = false) => {
    const userMsg = { type: isFile ? "image" : "user", text };
    setMessages((prev) => [...prev, userMsg]);
    setShowQuickReplies(false);

    try {
      const response = await axios.post("http://localhost:7700/question", {
        question: text,
      });
      setMessages((prev) => [
        ...prev,
        { type: "bot", text: response.data.answer },
      ]);
    } catch (err) {
     
      if(err.response?.data?.error){

        setMessages((prev) => [
          ...prev,
          { type: "bot", text: err.response.data.error },
        ]);
        return;
      }


      setMessages((prev) => [
        ...prev,
        { type: "bot", text: "❌ Sorry, something went wrong." },
      ]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim() !== "") {
      sendMessage(input);
      setInput("");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setUploadingImage(reader.result);
        sendMessage("[Image uploaded]", true);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Content Page_title="Broker Panel">
      <div style={styles.container}>
        <div style={styles.chatBox}>
          {messages.map((msg, idx) => (
            <div key={idx} style={styles.message}>
              {msg.type === "image" ? (
                <img src={uploadingImage} alt="Uploaded" style={styles.image} />
              ) : (
                <div
                  style={
                    msg.type === "user" ? styles.userMessage : styles.botMessage
                  }
                >
                  {msg.text}
                </div>
              )}
            </div>
          ))}
        </div>

        

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            style={styles.input}
            placeholder="Type your message..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <label style={{ cursor: "pointer" }}>
            📷
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              style={{ display: "none" }}
            />
          </label>
          <button type="submit" style={styles.sendButton}>
            Send
          </button>
        </form>
      </div>
    </Content>
  );
};

export default ChatBotPage;
